// Interface for Login Activity Form Data
export const LoginFormData = {
  activityType: 'login',
  dailyLoginLimit: 0,
  allTimeLoginLimit: 0,
  frequency: '',
  pointsEarned: 0,
  activeStartDate: new Date(),
  activeEndDate: new Date(),
  isDraft: false,
}

// Interface for Points On Order Delivery Activity Form Data
export const PointsOnOrderDeliveryFormData = {
  activityType: 'points-on-order-delivery',
  activityName: '',
  segments: [],
  orderType: '',
  dollarSpend: '',
  pointsEarned: '',
  activeStartDate: new Date(),
  activeEndDate: new Date(),
  isDraft: false,
}

// Interface for Welcome Activity Form Data
export const WelcomeFormData = {
  activityType: 'welcome',
  pointsEarned: '',
  activeStartDate: new Date(),
  activeEndDate: new Date(),
  hasEndDate: false,
  isDraft: false,
}

export const FormErrors = {}

export const ACTIVITY_TYPES = {
  LOGIN: 'login',
  WELCOME: 'welcome',
  POINTS_ON_ORDER_DELIVERY: 'points-on-order-delivery',
}

export const activityOptions = [
  {
    id: '1',
    type: 'welcome',
    displayName: 'Welcome',
  },
  {
    id: '2',
    type: 'login',
    displayName: 'Login',
  },
  {
    id: '3',
    type: 'points-on-order-delivery',
    displayName: 'Points On Order Delivery',
  },
]

export const orderTypeOptions = [
  {
    id: '1',
    type: 'online',
    displayText: 'Online',
  },
  {
    id: '2',
    type: 'offline',
    displayText: 'Offline',
  },
  {
    id: '3',
    type: 'all',
    displayText: 'Online & Offline',
  },
]

export const OrderType = {
  Online: 'Online',
  Offline: 'Offline',
  Both: 'Both',
}

export const ACTIVITY_TYPES_ENUM = {
  WELCOME: 'WELCOME',
  LOGIN: 'LOGIN',
  PLAY_GAME: 'PLAY_GAME',
  WATCH_VIDEO: 'WATCH_VIDEO',
  SURVEY: 'SURVEY',
  POINTS_TRANSFER: 'POINTS_TRANSFER',
  POINTS_ON_ORDER_DELIVERY: 'PRODUCT_PURCHASE',
  REDEEM_POINTS: 'REDEEM_POINTS',
  GENERIC_ACTIVITY: 'GENERIC_ACTIVITY',
}

export const ACTIVITY_TYPE = {
  WELCOME_ACTIVITY: 'Welcome Activity',
  LOGIN: 'Login',
  PLAY_GAME: 'Play Game',
  WATCH_VIDEO: 'Watch Video',
  SURVEY: 'Survey',
  POINTS_TRANSFER: 'Points Transfer',
  POINTS_ON_ORDER_DELIVERY: 'Points On Order Delivery',
  REDEEM_POINTS: 'Redeem Points',
  GENERIC_ACTIVITY: 'Generic Activity',
}

export const ACTIVITY_TYPE_TO_VALUE = {
  'Welcome Activity': 'WELCOME',
  'Login': 'LOGIN',
  'Points On Order Delivery': 'PRODUCT_PURCHASE',
}

export const WARNING_MESSAGE = {
  SCHEDULING_CONFLICT_DETECTED: 'Scheduling Conflict Detected',
}
